exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2klMmOCbxyaeb27ac91YxC{width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"KetExam_content": "_2klMmOCbxyaeb27ac91YxC"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/KetExam/style.postcss
// module id = 2019
// module chunks = 0